import { render, staticRenderFns } from "./FBABill.vue?vue&type=template&id=42b3081a&scoped=true"
import script from "./FBABill.vue?vue&type=script&lang=js"
export * from "./FBABill.vue?vue&type=script&lang=js"
import style0 from "./FBABill.vue?vue&type=style&index=0&id=42b3081a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3081a",
  null
  
)

export default component.exports